/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
// import { Dispatch, SetStateAction } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setStepDetails } from "src/redux/Actions/common";
import CustomButton from "src/shared/CustomButton";
import ReviewHeading from "src/shared/ReviewHeading";
import AssignmentNotice from "./AssignmentNotice";

function AssignmentNoticeReview() {
  const dispatch = useDispatch();
  const reviewStepNumber = useAppSelector((state): any => state.stepDetails.reviewStepNo);
  function onBack() {
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber - 1 }));
    window.scrollTo(0, 0);
  }
  function onNext() {
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber + 1 }));
    window.scrollTo(0, 0);
  }

  return (
    <div className="lg:ml-24 lg:mr-24 max-sm:ml-4 md:max-lg:px-10 max-sm:mr-4  font-montserrat pb-10">
      <ReviewHeading label="Assignment Notice" />
      <AssignmentNotice />
      <CustomButton onBack={onBack} onNext={onNext} />
    </div>
  );
}

export default AssignmentNoticeReview;
